<template>
  <label class="block mb-4">
    <span class="text-gray-700">{{ title }}</span>
    <input v-bind="$attrs"
           class="form-input block w-full mt-1"
           @change="$emit('input', $event.target.value)">
  </label>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    title: String
  }
};
</script>
